<template>
  <form @submit.prevent="submitForm">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/reports`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Отчет</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              Статус
            </label>
            <div class="col-md-9">
              {{ translateStatus(report.reportStatus) }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="report.excelFileId">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              Excel файл
            </label>
            <div class="col-md-9">
              <a href="javascript:void(0)" @click="onClickDownloadFile(report.excelFileId, report.name, 'xlsx')">
                {{ report.name }}.xlsx
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="report.pdfFileId">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              PDF файл
            </label>
            <div class="col-md-9">
              <a href="javascript:void(0)" @click="onClickDownloadFile(report.pdfFileId, report.name, 'pdf')">
                {{ report.name }}.pdf
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-9" v-if="canShowReason()">
        <div class="el-input-group">
          <label for="reason" class="form-label col-md-3">
            Причина отказа
          </label>
          <div class="col-md-9">
          <textarea v-model="report.reason"
                    :disabled="!canEditReason()"
                    id="reason"
                    style="width: 100%"
                    class="form-label" rows="5"></textarea>
          </div>
        </div>
      </div>

      <div class="row col-md-9" v-if="canShowJustification()">
        <div class="el-input-group">
          <label for="justification" class="form-label col-md-3">
            Комментарий
          </label>
          <div class="col-md-9">
          <textarea v-model="report.justification"
                    :disabled="!canEditJustification()"
                    id="justification"
                    style="width: 100%"
                    class="form-label" rows="5"></textarea>
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="page-footer justify-content-end">
      <div
          v-if="isUniversityManager() && (report.reportStatus === ReportStatusEnum.FILES_GENERATED.code)">
        <b-button variant="success"
                  type="submit"
                  @click="setStatus(ReportStatusEnum.SENT_FOR_APPROVAL.code)">
          Отправить на согласование
        </b-button>
      </div>

      <div v-if="isManagerFC() && report.reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code">
        <b-button variant="success" class="btn-mr"
                  type="submit"
                  @click="setStatus(ReportStatusEnum.SENT_TO_RECTOR.code)">
          Принять
        </b-button>

        <b-button variant="danger" class="btn-mr"
                  type="submit"
                  @click="setStatus(ReportStatusEnum.REJECTED_BY_FINANCIAL_CENTER.code)">
          Отказать
        </b-button>
      </div>

      <div
          v-if="isRector() && (report.reportStatus !== ReportStatusEnum.SIGNED_BY_RECTOR.code && report.reportStatus !== ReportStatusEnum.REJECTED_BY_RECTOR.code)">
        <b-button variant="success" class="btn-mr"
                  @click="onClickSignDocument(report.pdfFileId, report.uuid)">
          Подписать
        </b-button>

        <b-button variant="danger" class="btn-mr"
                  type="submit"
                  @click="setStatus(ReportStatusEnum.REJECTED_BY_RECTOR.code)">
          Отказать
        </b-button>
      </div>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import reportService from "@/services/reportService";
import delegationService from "@/services/delegationService";
import {ReportStatusEnum} from "@/enum/ReportStatusEnum";
import fileService, {convertFileBytesToBase64} from "@/services/fileService";
import signService from "@/services/ncaLayerService";
import {signDocument} from "@/services/signService";
import {watch} from "vue";

export default {
  components: {
    VueLoading
  },
  computed: {
    ReportStatusEnum() {
      return ReportStatusEnum
    },
    reportUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      reportStatus: null,
      report: {
        uuid: null,
        reportStatus: null,
        reason: null,
        justification: null
      },
      fileId: "",
      reportId: "",
    };
  },
  setup() {
    const {signCallback} = signService;
    watch(() => signCallback.callback, (newVal) => {
      if (newVal) {
        newVal(signCallback.result);
      }
    });
    signService.init();

    return {
      signService
    };
  },
  methods: {
    init() {
      this.findById(this.reportUuid);
    },
    async findById(reportUuid) {
      this.isLoading = true;
      this.report = await reportService.findByReportUuid(reportUuid);
      this.isLoading = false;
    },
    setStatus(reportStatus) {
      this.reportStatus = reportStatus;
    },
    async submitForm() {
      try {
        this.isLoading = true;

        if (this.reportStatus === ReportStatusEnum.SIGNED_BY_RECTOR.code) {
          /*this.report.reportStatus = this.reportStatus;
          this.report = await reportService.save(this.report);
          showSuccessNotify("Успешно сохранено!");*/
        } else {
          this.report.reportStatus = this.reportStatus;
          this.report = await reportService.save(this.report);
          showSuccessNotify("Успешно сохранено!");
        }
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    async onClickDownloadFile(fileId, name, fileExtention) {
      try {
        await fileService.download(fileId, `${name}.${fileExtention}`);
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    },
    async onClickSignDocument(fileId, reportId) {
      this.fileId = fileId;
      this.reportId = reportId;
      const token = localStorage.getItem("access_token");
      if (token) {
        const fileBytes = await fileService.downloadFileBytes(token, fileId);
        const base64ToSign = await convertFileBytesToBase64(fileBytes);
        this.signService.createCMSSignatureFromBase64(this.getSelectedStorage(), 'SIGNATURE', base64ToSign, false, this.onSignDocumentCallback);
      }
    },
    getSelectedStorage() {
      return localStorage.getItem('selectedStorage') || 'PKCS12';
    },
    async onSignDocumentCallback(response) {
      if (response.status) {
        const cms = response.result;
        const token = localStorage.getItem("access_token");
        if (token) {
          this.isLoading = true;
          await signDocument(token, this.fileId, this.reportId, cms);
          this.isLoading = false;
          showSuccessNotify("Отчет подписан");
          location.reload();
        }
      }
    },
    translateStatus(code) {
      const status = ReportStatusEnum[code];
      if (status) {
        return status.nameRu;
      }
      return "Неизвестно";
    },
    isDisabled() {
      const reportStatus = this.report.reportStatus;
      if (reportStatus && (reportStatus === ReportStatusEnum.SENT_TO_RECTOR.code || reportStatus === ReportStatusEnum.REJECTED_BY_FINANCIAL_CENTER.code)) {
        return true;
      } else if (this.isManagerFC()) {
        return true;
      } else if (this.isUniversityManager()) {
        if (reportStatus && reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code) {
          return true;
        }
        return false;
      }
      return true;
    },
    canShowReason() {
      if (!this.report) {
        return false;
      }

      const reportStatus = this.report.reportStatus;
      if (this.isRector()) {
        return false;
      } else if (this.isUniversityManager()) {
        if (reportStatus === ReportStatusEnum.QUEUED.code
            || reportStatus === ReportStatusEnum.FILES_GENERATING.code
            || reportStatus === ReportStatusEnum.FILES_GENERATED.code) {
          return false;
        }

        if (reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code) {
          return false;
        }
      } else if (this.isManagerFC()) {
        if (reportStatus === ReportStatusEnum.SENT_TO_RECTOR.code) {
          return false;
        }
      }

      return true;
    },
    canEditReason() {
      const reportStatus = this.report.reportStatus;
      if (this.isManagerFC()) {
        if (reportStatus && reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code) {
          return true;
        }
      }
      return false;
    },
    canShowJustification() {
      if (!this.report) {
        return false;
      }

      const reportStatus = this.report.reportStatus;
      if (reportStatus) {
        if (this.isRector()) {
          if (reportStatus === ReportStatusEnum.SENT_TO_RECTOR.code
              || reportStatus === ReportStatusEnum.REJECTED_BY_RECTOR.code) {
            return true;
          }
        } else if (this.isUniversityManager()) {
          if (reportStatus === ReportStatusEnum.REJECTED_BY_RECTOR.code) {
            return true;
          }
        }
      }

      return false;
    },
    canEditJustification() {
      const reportStatus = this.report.reportStatus;
      if (this.isRector()) {
        if (reportStatus && reportStatus === ReportStatusEnum.SENT_TO_RECTOR.code) {
          return true;
        }
      }
      return false;
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    isRector() {
      return delegationService.isRector();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.btn-mr {
  margin-right: 15px;
}

.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-excel {
  color: green;
}

.btn-pdf {
  color: #c43838;
}
</style>
